import { Flex, Text } from "@chakra-ui/react";
import React from "react";
import { DAYS } from "../../../helper/Constant";

function CalenderRow() {
  return (
    <Flex>
      <Flex
        width={"70px"}
        height={"60px"}
        background={"white"}
        boxShadow={"sm"}
        m={"0.5px"}
        mr={"2"}
        p={"0.5"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Text
          fontSize={"xs"}
          display={"flex"}
          width={"fit-content"}
          height={"fit-conten"}
          fontWeight={"medium"}
          justifyContent={"center"}
          alignItems={"center"}
          color={"#027dbbbf"}
        >
          Week
        </Text>
      </Flex>

      {DAYS.map((day) => (
        <Flex
          key={day}
          m={"0.5px"}
          width={"114px"}
          height={"60px"}
          background={"white"}
          boxShadow={"sm"}
          p={"0.5"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Text
            fontSize={"sm"}
            background={"white"}
            padding={"0px 8px"}
            boxShadow={"inset 0 0 2px 0px #023f5e"}
            rounded={"lg"}
            color={"#023f5e"}
            fontWeight={"medium"}
          >
            {day}
          </Text>
        </Flex>
      ))}
    </Flex>
  );
}

export default CalenderRow;
